import { get as _get } from 'lodash';
import { ReportComponent } from '@pwc/pwc-deals-report-ui';
import { Route } from 'react-router-dom';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getIsDarkModeSelector } from '../../common/redux/userSettings/userSettingsSlice';
import {
  isProjectArchived,
  isProjectInactive,
} from '../../common/helpers/projectStatusesUtils';
import {
  getProjectStatus,
  useProjectsStatuses,
} from '../../common/hooks/useProjectsStatuses';
import './Reports.scss';
import { getProject, getProjectSource } from '../project/projectSlice';
import { PROJECT_SOURCE } from '../project/projectUtil';

const ReportsContentRouter = () => {
  const projectsStates = useProjectsStatuses();
  const { navigation } = useSelector(getProject);
  const projectSource = useSelector(getProjectSource);

  const darkMode = useSelector(getIsDarkModeSelector);
  const themeName = useMemo(() => {
    if (darkMode === undefined) return 'default';
    return darkMode ? 'default' : 'light';
  }, [darkMode]);

  return (
    <Route
      path="/projects/:projectid/reports/"
      render={(props) => {
        const projectId = _get(props, ['match', 'params', 'projectid']);

        const projectStatus = getProjectStatus(projectsStates, projectId);
        const isProjectDisabled =
          projectId &&
          (isProjectInactive(projectStatus) ||
            isProjectArchived(projectStatus));
        return (
          <ReportComponent
            {...props}
            isProjectDisabled={isProjectDisabled}
            theme={themeName}
            navigation={navigation}
            isTpsEnabledForProject={projectSource === PROJECT_SOURCE.CDE}
          />
        );
      }}
    />
  );
};

export default ReportsContentRouter;
